import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './navbar.css'
import {RiMenu3Line, RiCloseLine} from 'react-icons/ri'
import Callbackpopup from '../../containers/callbackpopup/Callbackpopup'
import { CDN_URLS } from '../../config/cdnConfig';

const logo = CDN_URLS.LOGO;

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const navigate = useNavigate();

  // Check if we should show Tiranga (Jan 26 to Feb 1)
  const shouldShowTiranga = () => {
    const today = new Date();
    const republicDay = new Date(today.getFullYear(), 0, 26); // Jan 26
    const endDate = new Date(today.getFullYear(), 1, 1); // Feb 1
    return today >= republicDay && today <= endDate;
  };

  const showTiranga = shouldShowTiranga();

  const redirectToHome = () => {
    navigate('/');
  };
  const redirectToHomeInspectionPune = () => {
    navigate('/home-inspection-pune');
  }
  const redirectToHomeInspectionMumbai = () => {
    navigate('/home-inspection-mumbai');
  }
  const redirectToHomeInspectionBangalore = () => {
    navigate('/home-inspection-bangalore');
  }
  const redirectLegalServices = () => {
    navigate('/legal-property-services');
  }
  
  const redirectToBlog = () => {
    navigate('/blog');
  }
  
  const redirectToPartner = () => {
    navigate('/become-a-partner');
  }
  const redirectToThermalInspection = () => {
    navigate('/thermal-inspection');
  }
  const redirectToCareers = () => {
    navigate('/careers');
  }
  const redirectToLonavala = () => {
    navigate('/home-inspection-lonavala');
  }
  const redirectToHomeInspectionChennai = () => {
    navigate('/home-inspection-chennai');
  }

  const openCallbackPopup = () => {
    setPopupOpen(true);
    setToggleMenu(false);
    document.body.style.overflow = 'hidden';
  };

  const closeCallbackPopup = () => {
    setPopupOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className={`sng__navbar ${showTiranga ? 'sng__navbar-with-tiranga' : ''}`}>
      <div className='sng__navbar-links'>
        <div className='sng__navbar-links-logo' onClick={redirectToHome}>
          <img
            src={logo}
            alt="SnagEasy Logo"
            loading="eager"
            fetchPriority="high"
            width="180"
            height="50"
          />
        </div>
        <div className="sng__navbar-links_container">
          <p onClick={redirectToHome}>Home</p>
          <div 
            className="sng__navbar-services-dropdown"
            onMouseEnter={() => setShowServicesDropdown(true)}
            onMouseLeave={() => setShowServicesDropdown(false)}
          >
            <p className="sng__navbar-services-trigger">
              Services <span className={`dropdown-arrow ${showServicesDropdown ? 'open' : ''}`}>▼</span>
            </p>
            {showServicesDropdown && (
              <div 
                className="sng__navbar-services-menu"
                onMouseEnter={() => setShowServicesDropdown(true)}
                onMouseLeave={() => setShowServicesDropdown(false)}
              >
                <p onClick={() => { redirectToHomeInspectionPune(); setShowServicesDropdown(false); }}>
                  Home Inspection in Pune
                </p>
                <p onClick={() => { redirectToHomeInspectionMumbai(); setShowServicesDropdown(false); }}>
                  Home Inspection in Mumbai
                </p>
                <p onClick={() => { redirectToHomeInspectionBangalore(); setShowServicesDropdown(false); }}>
                  Home Inspection in Bangalore
                </p>
                <p onClick={() => { redirectToThermalInspection(); setShowServicesDropdown(false); }}>
                  Thermal Inspection
                  </p>
                <p onClick={() => { redirectToLonavala(); setShowServicesDropdown(false); }}>
                  Home Inspection in Lonavala
                </p>
                <p onClick={() => { redirectToHomeInspectionChennai(); setShowServicesDropdown(false); }}>
                  Home Inspection in Chennai
                </p>
              </div>
            )}
          </div>
          <p onClick={redirectLegalServices}>Legal</p>
          <p onClick={redirectToBlog}>Knowledge Center</p>
          <p onClick={redirectToPartner}>Become a SnagEasy Partner</p>
          <p onClick={redirectToCareers}>Careers</p>
        </div>
      </div>
      {showTiranga && (
        <div className='sng__navbar-tiranga-flag'>
          <img 
            src={`${CDN_URLS.REPUBLIC_DAY_FLAG}?t=${Date.now()}`}
            alt="Republic Day - Tiranga" 
            className="tiranga-flag-image"
          />
        </div>
      )}
      <div className="sng__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="sng__navbar-menu_container scale-up-center">
          <div className="sng__navbar-menu_container-links">
            <p onClick={() => { redirectToHome(); setToggleMenu(false); }}>Home</p>
            <div className="sng__navbar-mobile-services">
              <p 
                className="sng__navbar-mobile-services-trigger"
                onClick={() => setShowServicesDropdown(!showServicesDropdown)}
              >
                Services <span className="dropdown-arrow">{showServicesDropdown ? '▲' : '▼'}</span>
              </p>
              {showServicesDropdown && (
                <div className="sng__navbar-mobile-services-menu">
                  <p onClick={() => { redirectToHomeInspectionPune(); setToggleMenu(false); setShowServicesDropdown(false); }}>
                    Home Inspection in Pune
                  </p>
                  <p onClick={() => { redirectToHomeInspectionMumbai(); setToggleMenu(false); setShowServicesDropdown(false); }}>
                    Home Inspection in Mumbai
                  </p>
                  <p onClick={() => { redirectToHomeInspectionBangalore(); setToggleMenu(false); setShowServicesDropdown(false); }}>
                    Home Inspection in Bangalore
                  </p>
                  <p onClick={() => { redirectToThermalInspection(); setShowServicesDropdown(false); }}>
                  Thermal Inspection
                  </p>
                  <p onClick={() => { redirectToLonavala(); setToggleMenu(false); setShowServicesDropdown(false); }}>
                    Home Inspection in Lonavala
                  </p>
                  <p onClick={() => { redirectToHomeInspectionChennai(); setToggleMenu(false); setShowServicesDropdown(false); }}>
                    Home Inspection in Chennai
                  </p>
                </div>
              )}
            </div>
            <p onClick={() => { redirectLegalServices(); setToggleMenu(false); }}>Legal</p>
            <p onClick={() => { redirectToBlog(); setToggleMenu(false); }}>Knowledge Center</p>
            <p onClick={() => { redirectToPartner(); setToggleMenu(false); }}>Become a SnagEasy Partner</p>
            <p onClick={() => { redirectToCareers(); setToggleMenu(false); }}>Careers</p>
          </div>
          <div className="sng__navbar-menu_container-links-sign">
            <button type="button" className="sng__navbar-callback-btn-mobile" onClick={openCallbackPopup}>
              Request Callback
            </button>
          </div>
        </div>
        )}
      </div>
      {isPopupOpen && <Callbackpopup onClose={closeCallbackPopup} cardItem="Request Callback" />}
    </div>
  )
}

export default Navbar
